import participantsReducer from './reducers/participants';
import winnersReducer from './reducers/winners';

const mainReducer = (state, action) => ({
    participants: participantsReducer(state.participants, action),
    winners: winnersReducer(state.winners, action),
});

export default mainReducer;